import * as R from "ramda";
import axios from "../../axios-auth";
import qs from "qs";
import { getMediaUrl } from "../../helpers/helpers";
const state = {
  customer: null,
  isLogin: 1,
  customerImages: []
};

const getters = {
  getCustomer: state => {
    return state.customer;
  },
  getIsLogin: state => {
    return state.isLogin;
  },
  getCustomerImages: state => {
    return R.pathOr([], ["customerImages"], state);
  },
  getCustomerImageGalleryItems: (state, getters) => {
    const items = getters.getCustomerImages;

    const baseUrl = getters.getUrl("mediaBaseUrl");

    return R.mapObjIndexed(item => {
      return {
        id: item.uuid,
        url: getMediaUrl(R.pathOr("", ["thumbnails", "thumb"], item), baseUrl)
      };
    }, items);
  }
};

const mutations = {
  setCustomer: (state, payload) => {
    state.customer = payload;
  },
  setIsLogin: (state, payload) => {
    if (payload) state.isLogin = 1;
    else state.isLogin = 0;
  },
  addCustomerImage: (state, uuid) => {
    state.customerImages = [...state.customerImages, uuid];
  },
  emptyCustomerGallery: (state, all) => {
    if (all) state.customerImages = [];
    else {
      state.customerImages = R.filter(item => {
        const uploaded = R.pathOr(false, ["uploaded"], item);
        return uploaded;
      }, state.customerImages);
    }
  },
  deleteCustomerImage: (state, uuid) => {
    state.customerImages = R.filter(item => {
      return item.uuid !== uuid;
    }, state.customerImages);
  }
};

const actions = {
  loadCustomerGallery: ({ commit, getters, dispatch }, payload) => {
    axios.instance
      .post(getters.getUrl("apiCustomerGalleryUrl"), {
        customer: getters.getCustomer
      })
      .then(response => {
        const { success, data } = response.data;
        if (success) {
          R.forEach(item => {
            item.uploaded = false;
            commit("addCustomerImage", item);
          }, data);
        }
      })
      .catch(error => {
        console.log("Error " + error);
      });
  },
  setCustomer: ({ commit }, payload) => {
    commit("setCustomer", payload);
  },
  setIsLogin: ({ commit }, payload) => {
    commit("setIsLogin", payload);
  },
  addCustomerImage: ({ commit }, payload) => {
    commit("addCustomerImage", payload);
  },
  emptyCustomerGallery: ({ commit }, all) => {
    commit("emptyCustomerGallery", all);
  },
  deleteCustomerImage: ({ commit, getters }, payload) => {
    commit("deleteCustomerImage", payload);
    axios.instance
      .post(getters.getUrl("apiDeleteImageUrl") + payload, {
        customer: getters.getCustomer
      })
      .then(result => {
        var response = result.data;
      })
      .catch(error => {
        console.log(error);
      });
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
